<template>
  <div class="wrapper" :class="styles">
    <component v-if="prefixIcon" :is="prefixIcon" />
    <TextInput class="input" v-model="textValue" v-bind="$attrs" v-on="$listeners" />
    <Button v-if="suffixIcon" icon @click.stop="onClickSuffix">
      <component :is="suffixIcon" />
    </Button>
  </div>
</template>

<script>
import TextInput from '@/components/atoms/TextInput'
import Button from '@/components/atoms/Button'

export default {
  name: 'AdornmentsInput',
  components: {
    TextInput,
    Button,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      required: true,
      type: String,
    },
    prefixIcon: {
      required: false,
      type: Object,
    },
    suffixIcon: {
      required: false,
      type: Object,
    },
  },
  computed: {
    textValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    styles() {
      return {
        'has-prefix': !!this.prefixIcon,
        'has-suffix': !!this.suffixIcon,
      }
    },
  },
  methods: {
    onClickSuffix() {
      this.$emit('onClickSuffix')
    },
  },
}
</script>

<style lang="postcss" scoped>
.wrapper {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--light-gray);
  border-radius: 4px;
  box-sizing: border-box;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  grid-gap: 8px;
  height: 42px;
  padding: 0 16px 0 16px;
  width: 100%;

  &.has-prefix {
    grid-auto-columns: auto 1fr;
  }

  &.has-suffix {
    grid-auto-columns: 1fr auto;
  }

  &.has-prefix.has-suffix {
    grid-auto-columns: auto 1fr auto;
  }

  svg {
    fill: var(--gray-1);
    flex: 0 0 auto;
  }

  .input {
    border: none;
    height: 100%;
    outline: 0;
    padding: 0;
  }
}
</style>
